import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "search-control",
  id: "search-control"
}
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "tab-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConcordanceSearch = _resolveComponent("ConcordanceSearch")!
  const _component_SegmentSearch = _resolveComponent("SegmentSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          id: "search-source-tab",
          class: _normalizeClass(['tab-item', { active: _ctx.searchField === _ctx.SearchField.Source }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchField(_ctx.SearchField.Source)))
        }, _toDisplayString(_ctx.$t('segmentSearch.sourceSegment')), 3),
        _createElementVNode("span", {
          id: "search-target-tab",
          class: _normalizeClass(['tab-item', { active: _ctx.searchField === _ctx.SearchField.Target }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSearchField(_ctx.SearchField.Target)))
        }, _toDisplayString(_ctx.$t('segmentSearch.targetSegment')), 3)
      ]),
      _createVNode(_component_ConcordanceSearch, { translationConfig: _ctx.translationConfig }, null, 8, ["translationConfig"])
    ]),
    _createVNode(_component_SegmentSearch, { searchField: _ctx.searchField }, null, 8, ["searchField"])
  ]))
}